/* eslint-disable import/prefer-default-export */
export enum UserType {
  CREATE_USER = 'UserType/CREATE_USER',
  UPDATE_USER = 'UserType/UPDATE_USER',
  LOGOUT = 'UserType/LOGOUT',
  DEFINE_FIRSTNAME = 'UserType/DEFINE_FIRSTNAME',
  DEFINE_LASTNAME = 'UserType/DEFINE_LASTNAME',
  DEFINE_MAIL = 'UserType/DEFINE_MAIL',
  DEFINE_VALUE_USER = 'UserType/DEFINE_VALUE_USER',
  RESET_USER = 'UserType/RESET_USER',
  DEFINE_STRIPEID = 'UserType/DEFINE_STRIPEID',
  //added in 2.4.0
  SIGN_CGU = 'UserType/SIGN_CGU'
}
